// extracted by mini-css-extract-plugin
module.exports = {"phoneIcon":"_cef308e7","link":"_282c4930"};